module.exports = __webpack_public_path__ + "static/mexico-4148fef00e325c1c627195f2dcc21e4f.svg";